import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";
import { useDispatch, useSelector } from "react-redux";
import {
  GREEN_AS_PER_BACKEND,
  PURPLE_AS_PER_BACKEND,
  RED_AS_PER_BACKEND,
} from "../store/businesslogic/dict";
import {
  changeHelpOrTipText,
  getHelpOrTipText,
  helpOrTipHidden,
  helpOrTipShowed,
} from "../store/components";
import * as theme from "../theme";

const dotColorDecider = (text) => {
  if (text === PURPLE_AS_PER_BACKEND) {
    return theme.COLORS.purple_dot;
  }
  if (text === RED_AS_PER_BACKEND) {
    return theme.COLORS.red_dot;
  }
  if (text === GREEN_AS_PER_BACKEND) {
    return theme.COLORS.green_dot;
  }
  return "white";
};

const dotTextDecider = (text) => {
  if (text === PURPLE_AS_PER_BACKEND) {
    return "This cover represents more than 100% of client needs";
  }
  if (text === RED_AS_PER_BACKEND) {
    return "This cover represents less than 100% of client needs";
  }
  if (text === GREEN_AS_PER_BACKEND) {
    return "This cover represents 100% of client needs";
  }
  return "white";
};

const ColorDotCompareView = ({ covermatchcolor }) => {
  const dispatch = useDispatch();

  const handleMouseOver = () => {
    dispatch(changeHelpOrTipText(dotTextDecider(covermatchcolor)));
    // dispatch(helpOrTipShowed());
  };
  const handleMouseOut = () => {
    dispatch(changeHelpOrTipText(""));
    // dispatch(helpOrTipHidden());
  };

  return (
    <FiberManualRecordIcon
      onMouseOver={handleMouseOver}
      onMouseOut={handleMouseOut}
      style={{
        color: dotColorDecider(covermatchcolor),
        fontSize: "1.6vmin",
      }}
    ></FiberManualRecordIcon>
  );
};

export default ColorDotCompareView;
